import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginPage } from './pages/login/login.component';
import { DashboardPage } from './pages/dashboard/dashboard.component';
import { SlokaTypesListPage } from './pages/sloka-types-list/sloka-types-list.component';
import { AddSlokaTypePage } from './pages/add-sloka-type/add-sloka-type.component';
import { AddSlokaPage } from './pages/add-sloka/add-sloka.component';
import { SlokasListPage } from './pages/slokas-list/slokas-list.component';
import { UsersPage } from './pages/users/users.component';
import { AddOfferPage } from './pages/add-offer/add-offer.component';
import { ProfilePage } from './pages/profile/profile.component';
import { BooksListComponent } from './pages/books-list/books-list.component';
import { AddBookComponent } from './pages/add-book/add-book.component';
import { EventListComponent } from './pages/event-list/event-list.component';
import { AddEventComponent } from './pages/add-event/add-event.component';
import { BlogPostListComponent } from './pages/blog-post-list/blog-post-list.component';
import { AddBlogPostComponent } from './pages/add-blog-post/add-blog-post.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'page',
    redirectTo: 'page/sloka-types-list',
    pathMatch: 'full',
  },
  {
    path: 'login',
    component: LoginPage,
  },
  {
    path: 'page',
    component: DashboardPage,
    children: [
      {
        path: 'sloka-types-list',
        component: SlokaTypesListPage,
      },
      {
        path: 'add-sloka-type',
        component: AddSlokaTypePage,
      },
      {
        path: 'sloka-type/:id',
        component: AddSlokaTypePage,
      },
      {
        path: 'slokas-list',
        component: SlokasListPage,
      },
      {
        path: 'add-sloka',
        component: AddSlokaPage,
      },
      {
        path: 'sloka/:id',
        component: AddSlokaPage,
      },
      {
        path: 'users',
        component: UsersPage,
      },
      {
        path: 'add-offer',
        component: AddOfferPage,
      },
      {
        path: 'profile',
        component: ProfilePage,
      },
      {
        path: 'books-list',
        component: BooksListComponent,
      },
      {
        path: 'add-book',
        component: AddBookComponent,
      },
      {
        path: 'books/:id',
        component: AddBookComponent,
      },
      {
        path: 'events-list',
        component: EventListComponent,
      },
      {
        path: 'add-event',
        component: AddEventComponent,
      },
      {
        path: 'events/:id',
        component: AddEventComponent,
      },
      {
        path: 'blog-post-list',
        component: BlogPostListComponent,
      },
      {
        path: 'add-blog-post',
        component: AddBlogPostComponent,
      },
      {
        path: 'blog-post/:id',
        component: AddBlogPostComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
